import { render, staticRenderFns } from "./BCQueues.vue?vue&type=template&id=355be7c4&scoped=true"
import script from "./BCQueues.vue?vue&type=script&lang=js"
export * from "./BCQueues.vue?vue&type=script&lang=js"
import style0 from "./BCQueues.vue?vue&type=style&index=0&id=355be7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355be7c4",
  null
  
)

export default component.exports